// extracted by mini-css-extract-plugin
export default {"about-item":"AboutItem_about-item__4bESE","title":"AboutItem_title__Te4VI","description":"AboutItem_description__Bjw1Z"};